import { CAMetadataState, METADATA_GETTER_IVA, METADATA_GETTER_MAPEO_ESTADOS, METADATA_GETTER_MINIMO_UFS_PLATAFORMA, METADATA_GETTER_PRECIO_UFS, METADATA_GETTER_USUARIOS_SALES, METADATA_MUTATION_IVA, METADATA_MUTATION_MAPEO_ESTADOS, METADATA_MUTATION_MINIMO_UFS_PLATAFORMA, METADATA_MUTATION_PRECIO_UFS, METADATA_MUTATION_USUARIOS_SALES } from './metadata.types';

// Estado inicial del store del metadata
const state: CAMetadataState = {
  precio_ufs: null,
  minimo_ufs_plataforma: null,
  iva: null,
  mapeo_estados: null,
  usuarios_sales: null
};

// Getters de metadata
const getters = {

  /**
   * Metodo para recuperar los precios de los ufs
   * 
   * @param state 
   * @returns Los precios de las ufs
   */
  [METADATA_GETTER_PRECIO_UFS](state: CAMetadataState) {
    return state.precio_ufs;
  },

  /**
   * Metodo para recuperar el minimo de ufs permitidas en la plataforma
   * 
   * @param state 
   * @returns La cantidad minima de ufs permitidas
   */
  [METADATA_GETTER_MINIMO_UFS_PLATAFORMA](state: CAMetadataState) {
    return state.minimo_ufs_plataforma;
  },

  /**
   * Metodo para recuperar el valor del iva
   * 
   * @param state 
   * @returns Valor del iva
   */
  [METADATA_GETTER_IVA](state: CAMetadataState) {
    return state.iva;
  },

  /**
   * Metodo para recuperar el mapeo de estados de los acuerdos comerciales
   * 
   * @param state 
   * @returns Lista con los mapeos de estados (esta lista incluye el siguiente estado por el que puede pasar un acuerdo)
   */
  [METADATA_GETTER_MAPEO_ESTADOS](state: CAMetadataState) {
    return state.mapeo_estados;
  },

  /**
   * Metodo para recuperar el mapeo de estados de los acuerdos comerciales
   * 
   * @param state 
   * @returns Lista de usuarios sales
   */
  [METADATA_GETTER_USUARIOS_SALES](state: CAMetadataState) {
    return state.usuarios_sales;
  }
};

// Mutations de metadata
const mutations = {

  /**
   * Seteamos los valores de los precios de los ufs (tanto para los barrios como para los edificios)
   *
   * @param state
   * @param precio_ufs
   */
  [METADATA_MUTATION_PRECIO_UFS](state: CAMetadataState, precio_ufs) {
    state.precio_ufs={
      precio_barrio: precio_ufs.precio_barrio,
      precio_edificio: precio_ufs.precio_edificio
    };
  },

  /**
   * Seteamos el valor del minimo de ufs permitidas en la plataforma
   * 
   * @param state 
   * @param minimo_ufs_plataforma
   */
  [METADATA_MUTATION_MINIMO_UFS_PLATAFORMA](state: CAMetadataState, minimo_ufs_plataforma: number) {
    state.minimo_ufs_plataforma = minimo_ufs_plataforma;
  },

  /**
   * Seteamos el valor del iva (que se utilizara en diferentes lugares en el satelite)
   * 
   * @param state 
   * @param iva
   */
  [METADATA_MUTATION_IVA](state: CAMetadataState, iva: number) {
    state.iva = iva;
  },

  /**
   * Seteamos el valor de los mapeos de los estados (con el posible estado siguiente) de los acuerdos comerciales
   * 
   * @param state 
   * @param mapeo_estados
   */
  [METADATA_MUTATION_MAPEO_ESTADOS](state: CAMetadataState, mapeo_estados: { [estado_actual: string]: string }) {
    state.mapeo_estados = mapeo_estados;
  },

  /**
   * Seteamos el valor de los usuarios de sales
   * 
   * @param state 
   * @param usuarios_sales
   */
  [METADATA_MUTATION_USUARIOS_SALES](state: CAMetadataState, usuarios_sales: string[]) {
    state.usuarios_sales = usuarios_sales;
  },
};

export default {
  state,
  getters,
  mutations
};
